var cookiesLib = require("./cookies");
var gallery = require("./gallery.js");
$(document).ready(function() 
{
	var turnFavRed = function() {
		$(".heart-icon").addClass("hidden");
		$(".heart-icon-red").removeClass("hidden");
	};

	var turnFavBlue = function() {
		$(".heart-icon-red").addClass("hidden");
		$(".heart-icon").removeClass("hidden");
	};

	var checkFavsIsRed = function() {
		return !($(".heart-icon-red").hasClass("hidden"));
	};

    var postId = $("#postId").val();
	if (!postId) {
		$("#blogGallery").each(gallery.runGallery);
		return;
	}
	var favorites = cookiesLib.getCookie("favoritesTours") ? cookiesLib.getCookie("favoritesTours").split(",") : [];
	var favBtns = $("#post-favorites-top,#post-favorites-down");
    if (favorites.indexOf(postId) != -1) {
		turnFavRed();
	} else {
		turnFavBlue();
	}

    favBtns.on("click", function (event) {
		event.preventDefault();
		//Check debounce lock
		if (window["unlocked_" + this.id] !== false) {
			window["unlocked_" + this.id] = false; //Lock to prevent multiple clicks before completion

			try {
				favorites = cookiesLib.getCookie("favoritesTours") ? cookiesLib.getCookie("favoritesTours").split(",") : [];
				
				var addTour = !checkFavsIsRed();
				
				var favoritesLength = favorites.length;
				/* if not exists a favorites in cookie than create a list of favorites in cookie */
				if (addTour && favorites.length == 0)
				{
					cookiesLib.setCookie('favoritesTours', postId, 180);
					favoritesLength++;
					turnFavRed();
				} 
				else if (addTour && favorites.indexOf(postId) == -1)
				{     	
					favorites.push(postId);
					cookiesLib.setCookie('favoritesTours', favorites.join(','), 180);
					favoritesLength++;
					turnFavRed();
				} 
				else if (!addTour)
				{
					cookiesLib.setCookie('favoritesTours', cookiesLib.getCookie("favoritesTours").replace(","+postId, "").replace(postId, ""), 180);
					favoritesLength--;
					turnFavBlue();
				}
			
				if (favoritesLength > 0) {
					if($(".fav-notification").hasClass("hide")) {
						$(".fav-notification").removeClass("hide");
					}
						
					$(".fav-notification").html(favoritesLength.toString());
					$(".fav-notification").show();
				}            
				else {
					$(".fav-notification").hide();
				}

			} finally {
				window["unlocked_" + this.id] = true;
			}
		}
		event.stopPropagation();
	});
	$("#blogGallery").each(gallery.runGallery);
});


// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/blog.js